import { render, staticRenderFns } from "./TripEventsWidget.vue?vue&type=template&id=fdb567e6&scoped=true&"
import script from "./TripEventsWidget.vue?vue&type=script&lang=js&"
export * from "./TripEventsWidget.vue?vue&type=script&lang=js&"
import style0 from "./TripEventsWidget.vue?vue&type=style&index=0&id=fdb567e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb567e6",
  null
  
)

export default component.exports